class PaginationController {

	$onInit() {
		this.selectedPage = this.selectedPage ? this.selectedPage : 1;
		this.totalElements = this.totalElements ? this.totalElements : 0;
		this.elementsForPage = this.elementsForPage ? this.elementsForPage : 1;
		this.fillArrayPages();
		
	}
	$onChanges(changes) {
		if (changes.totalElements) {
			this.totalElements=this.totalElements;
			
			this.fillArrayPages();
		}
	}

	/*
     * Fill the array with the number of pages according to totalElements and elementsForPage
     */
	fillArrayPages() {
		this.pages = [];		
		let pages = Math.floor(this.totalElements / this.elementsForPage);
		if (this.totalElements % this.elementsForPage !== 0)
			pages++;
		this.max = pages;
		pages = pages > 10 ? 10 : pages;
		for (let i = 1; i <= pages; i++)
			this.pages.push(i);
	}

	/*
     * Change selectd page, call onSelectedPageChanged callback
     */
	changeSelectedPage(page) {
		if (this.selectedPage !== page) {
			this.selectedPage = page;
			if (angular.isFunction(this.onChange))
				this.onChange({
					$event: {
						page: this.selectedPage
					}
				});
		}
	}

	/*
     * Go backward on the dates carousel
     */
	goBackward() {
		if (this.pages[0] > 1) {
			let pages = [];
			angular.forEach(this.pages, function (item) {
				pages.push(item - 1);
			});
			this.pages = pages;
		}
	}

	/*
     * Go forward on the dates carousel
     */
	goForward() {
		if (this.pages[this.pages.length - 1] < this.max) {
			let pages = [];
			angular.forEach(this.pages, function (item) {
				pages.push(item + 1);
			});
			this.pages = pages;
		}
	}
}

export default PaginationController;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/pagination/pagination.controller.js